export const MAX_CHARACTERS_TOPIC_FIELD = 30;

export const TOPICS_ARRAY_LENGTH = 4;
